export default {
    text_wrap: {
        icon: [
            22,
            22,
            [],
            "f111",
            "M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
        ],
        iconName: "text_wrap",
        prefix: "exo"
    },

    group_remove: {
        icon: [
            22,
            22,
            [],
            "f111",
            "M 4 6 H 2 v 14 c 0 1.1 0.9 2 2 2 h 14 v -2 H 4 V 6 z m 16 -4 H 8 c -1.1 0 -2 0.9 -2 2 v 12 c 0 1.1 0.9 2 2 2 h 12 c 1.1 0 2 -0.9 2 -2 V 4 c 0 -1.1 -0.9 -2 -2 -2 z m 0 14 H 8 V 4 h 12 v 12 z m -5 -5 h 3 V 9 h -3 h -5 v 2 z"
        ],
        iconName: "group_remove",
        prefix: "exo"
    },

    group_move: {
        icon: [
            22,
            22,
            [],
            "f111",
            "M 4 6 H 2 v 14 c 0 1.1 0.9 2 2 2 h 14 v -2 H 4 V 6 z m 16 -4 H 8 c -1.1 0 -2 0.9 -2 2 v 12 c 0 1.1 0.9 2 2 2 h 12 c 1.1 0 2 -0.9 2 -2 V 4 c 0 -1.1 -0.9 -2 -2 -2 z m 0 14 H 8 V 4 h 12 v 12 z m -2 -6 L 15 6 L 15 9 L 10 9 L 10 11 L 15 11 L 15 11 L 15 14 z"
        ],
        iconName: "group_move",
        prefix: "exo"
    },

    group_add: {
        icon: [
            22,
            22,
            [],
            "f111",
            "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zm-7-2h2v-3h3V9h-3V6h-2v3h-3v2h3z"
        ],
        iconName: "group_add",
        prefix: "exo"
    },

    format_text: {
        icon: [
            22,
            22,
            [],
            "f111",
            "M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"
        ],
        iconName: "format_text",
        prefix: "exo"
    },

    rules: {
        icon: [
            1100,
            1000,
            [],
            "59505",
            "M986.585 500.185L827.077 340.677c-7.877-7.877-21.662-7.877-29.539 0L768 370.215c-7.877 7.877-7.877 21.662 0 29.539l49.23 49.23c7.878 7.878 1.97 23.631-9.845 23.631h-435.2l259.938-257.969c7.877-7.877 23.63-1.97 23.63 9.846v70.893c0 11.815 7.878 19.692 19.693 19.692H716.8c11.815 0 19.692-7.877 19.692-19.692V66.954c0-11.816-7.877-19.692-19.692-19.692H492.308c-9.846 0-19.693 9.846-19.693 21.661v39.385c0 11.815 7.877 19.692 19.693 19.692H563.2c11.815 0 17.723 13.785 9.846 23.63L254.031 470.647H59.077c-11.815 0-19.692 9.846-19.692 21.662v41.354c0 11.815 11.815 21.661 21.661 21.661H257.97L575.015 872.37c7.877 7.877 1.97 23.631-9.846 23.631h-70.892c-11.815 0-19.692 7.877-19.692 19.692v39.385c0 9.846 7.877 19.692 19.692 21.661h224.492c11.816 0 19.693-7.876 19.693-19.692V730.585c0-11.816-7.877-19.693-19.693-19.693h-41.354c-11.815 0-19.692 7.877-19.692 19.693v70.892c0 11.815-13.785 17.723-23.63 9.846l-259.94-256h435.2c11.816 0 17.724 15.754 9.847 23.63L768 628.186c-7.877 7.877-7.877 21.661 0 29.538l29.538 29.539c7.877 7.876 21.662 7.876 29.539 0l159.508-157.539c7.877-9.846 7.877-21.661 0-29.538z"
        ],
        iconName: "rules",
        prefix: "exo"
    },

    dragable: {
        icon: [
            1100,
            1000,
            [],
            "59403",
            "M290 80c0 38.7 31.3 70 70 70s70-31.3 70-70-31.3-70-70-70-70 31.3-70 70zM570 80c0 38.7 31.3 70 70 70s70-31.3 70-70-31.3-70-70-70-70 31.3-70 70zM290 360c0 38.7 31.3 70 70 70s70-31.3 70-70-31.3-70-70-70-70 31.3-70 70zM570 360c0 38.7 31.3 70 70 70s70-31.3 70-70-31.3-70-70-70-70 31.3-70 70zM290 640c0 38.7 31.3 70 70 70s70-31.3 70-70-31.3-70-70-70-70 31.3-70 70zM570 640c0 38.7 31.3 70 70 70s70-31.3 70-70-31.3-70-70-70-70 31.3-70 70zM290 920c0 38.7 31.3 70 70 70s70-31.3 70-70-31.3-70-70-70-70 31.3-70 70zM570 920c0 38.7 31.3 70 70 70s70-31.3 70-70-31.3-70-70-70-70 31.3-70 70z"
        ],
        iconName: "dragable",
        prefix: "exo"
    },

    field_text: {
        icon: [
            1000,
            1000,
            [],
            "59400",
            "M937.5 250H281.3V187.5H375V125H281.3 218.8 125V187.5H218.8V250H62.5C25 250 0 281.3 0 312.5V687.5C0 725 25 750 62.5 750H218.8V812.5H125V875H375V812.5H281.3V750H937.5C975 750 1000 725 1000 687.5V312.5C1000 281.3 975 250 937.5 250ZM62.5 687.5V312.5H218.8V687.5H62.5ZM937.5 687.5H281.3V312.5H937.5V687.5Z"
        ],
        iconName: "field_text",
        prefix: "exo"
    },

    field_textarea: {
        icon: [
            1000,
            1000,
            [],
            "59399",
            "M187.5 687.5V625H687.5V687.5H187.5L187.5 687.5ZM187.5 437.5H812.5V375H187.5V437.5L187.5 437.5ZM187.5 500V562.5H812.5V500H187.5L187.5 500ZM812.5 250H187.5V312.5H812.5V250L812.5 250ZM1000 875V125C1000 87.5 975 62.5 937.5 62.5H62.5C25 62.5 0 87.5 0 125V875C0 912.5 25 937.5 62.5 937.5H937.5C975 937.5 1000 912.5 1000 875ZM937.5 125V875H62.5V125H937.5Z"
        ],
        iconName: "field_textarea",
        prefix: "exo"
    },

    field_radio_group: {
        icon: [
            1000,
            1000,
            [],
            "59396",
            "M0 62.5H1000V0H0V62.5ZM0 187.5H1000V125H0V187.5ZM312.5 375H937.5V312.5H312.5V375ZM937.5 562.5H312.5V625H937.5V562.5ZM937.5 875V812.5H312.5V875H937.5ZM93.8 437.5C43.8 437.5 0 393.8 0 343.8S43.8 250 93.8 250 187.5 293.8 187.5 343.8 143.8 437.5 93.8 437.5ZM93.8 312.5C75 312.5 62.5 325 62.5 343.8S75 375 93.8 375 125 362.5 125 343.8 112.5 312.5 93.8 312.5ZM93.8 693.8C43.8 693.8 0 650 0 600S43.8 506.3 93.8 506.3 187.5 543.8 187.5 600 143.8 693.8 93.8 693.8ZM93.8 568.8C75 568.8 62.5 581.3 62.5 600S75 631.3 93.8 631.3 125 612.5 125 600 112.5 568.8 93.8 568.8ZM93.8 937.5C43.8 937.5 0 893.8 0 843.8S43.8 750 93.8 750 187.5 793.8 187.5 843.8 143.8 937.5 93.8 937.5ZM93.8 812.5C75 812.5 62.5 825 62.5 843.8S75 875 93.8 875 125 862.5 125 843.8 112.5 812.5 93.8 812.5Z"
        ],
        iconName: "field_radio_group",
        prefix: "exo"
    },

    field_select: {
        icon: [
            1000,
            1000,
            [],
            "59398",
            "M0 0V875H0C0 912.5 25 937.5 62.5 937.5H687.5C725 937.5 750 912.5 750 875H750V312.5H1000V0H0ZM62.5 62.5H687.5V250H62.5V62.5ZM62.5 437.5H687.5V625H62.5V437.5ZM62.5 875V687.5H687.5V875H62.5ZM937.5 250H750V62.5H937.5V250ZM125 125H187.5V187.5H125V125ZM125 750H187.5V812.5H125V750ZM250 750H312.5V812.5H250V750ZM375 750H437.5V812.5H375V750ZM562.5 750V812.5H500V750H562.5ZM125 500H187.5V562.5H125V500ZM250 500H312.5V562.5H250V500ZM375 500H437.5V562.5H375V500ZM843.8 193.8L781.3 125H900L843.8 193.8ZM125 375V312.5H187.5V375H125L125 375ZM250 375V312.5H312.5V375H250L250 375Z"
        ],
        iconName: "field_select",
        prefix: "exo"
    },

    field_number: {
        icon: [
            1000,
            1000,
            [],
            "59409",
            "M875 375V250H718.6L749.9 0H624.9L593.6 250H343.7L374.9 0H249.9L218.7 250H0V375H203.1L171.9 625H0V750H156.3L125 1000H250L281.3 750H531.2L499.9 1000H625L656.3 750H875V625H671.9L703 375H875ZM546.8 625H296.9L328.1 375H578L546.8 625Z"
        ],
        iconName: "field_number",
        prefix: "exo"
    },

    field_hidden: {
        icon: [
            1000,
            1000,
            [],
            "59503",
            "M62.5 312.5L125 312.5 125 250 62.5 250ZM187.5 312.5L250 312.5 250 250 187.5 250ZM312.5 312.5L375 312.5 375 250 312.5 250ZM437.5 312.5L500 312.5 500 250 437.5 250ZM562.5 312.5L625 312.5 625 250 562.5 250ZM687.5 312.5L750 312.5 750 250 687.5 250ZM812.5 312.5L875 312.5 875 250 812.5 250ZM0 375L62.5 375 62.5 312.5 0 312.5ZM937.5 437.5L1000 437.5 1000 375 937.5 375ZM0 500L62.5 500 62.5 437.5 0 437.5ZM937.5 562.5L1000 562.5 1000 500 937.5 500ZM0 625L62.5 625 62.5 562.5 0 562.5ZM937.5 687.5L1000 687.5 1000 625 937.5 625ZM125 750L187.5 750 187.5 687.5 125 687.5ZM250 750L312.5 750 312.5 687.5 250 687.5ZM375 750L437.5 750 437.5 687.5 375 687.5ZM500 750L562.5 750 562.5 687.5 500 687.5ZM625 750L687.5 750 687.5 687.5 625 687.5ZM750 750L812.5 750 812.5 687.5 750 687.5ZM875 750L937.5 750 937.5 687.5 875 687.5ZM937.5 312.5L1000 312.5 1000 250 937.5 250ZM0 750L62.5 750 62.5 687.5 0 687.5Z"
        ],
        iconName: "field_hidden",
        prefix: "exo"
    },

    form: {
        icon: [
            22,
            22,
            [],
            "f111",
            "M 4 15 h 7 v 2 H 4 z m 0 -4 h 10 v 2 H 4 z m 0 -4 h 10 v 2 H 4 z m 12 -4 h -4.18 C 11.4 1.84 10.3 1 9 1 c -1.3 0 -2.4 0.84 -2.82 2 H 2 c -0.14 0 -0.27 0.01 -0.4 0.04 c -0.39 0.08 -0.74 0.28 -1.01 0.55 c -0.18 0.18 -0.33 0.4 -0.43 0.64 c -0.1 0.23 -0.16 0.49 -0.16 0.77 v 14 c 0 0.27 0.06 0.54 0.16 0.78 s 0.25 0.45 0.43 0.64 c 0.27 0.27 0.62 0.47 1.01 0.55 c 0.13 0.02 0.26 0.03 0.4 0.03 h 14 c 1.1 0 2 -0.9 2 -2 V 5 c 0 -1.1 -0.9 -2 -2 -2 z m -7 -0.25 c 0.41 0 0.75 0.34 0.75 0.75 s -0.34 0.75 -0.75 0.75 s -0.75 -0.34 -0.75 -0.75 s 0.34 -0.75 0.75 -0.75 z M 16 19 H 2 V 5 h 14 v 14 z"
        ],
        iconName: "form",
        prefix: "exo"
    },
    preview: {
        icon: [
            22,
            22,
            [],
            "f111",
            "M 18.9 1.3 H 3.5 C 2.279 1.3 1.3 2.29 1.3 3.5 v 15.4 c 0 1.21 0.979 2.2 2.2 2.2 h 15.4 c 1.21 0 2.2 -0.99 2.2 -2.2 V 3.5 C 21.1 2.29 20.121 1.3 18.9 1.3 z M 18.9 18.9 H 3.5 V 5.7 h 15.4 V 18.9 z M 12.85 12.3 c 0 0.913 -0.737 1.65 -1.65 1.65 s -1.65 -0.737 -1.65 -1.65 c 0 -0.913 0.737 -1.65 1.65 -1.65 S 12.85 11.387 12.85 12.3 z M 11.2 7.9 c -3.003 0 -5.566 1.826 -6.6 4.4 c 1.034 2.574 3.597 4.4 6.6 4.4 s 5.566 -1.826 6.6 -4.4 C 16.766 9.726 14.203 7.9 11.2 7.9 z M 11.2 15.05 c -1.518 0 -2.75 -1.232 -2.75 -2.75 c 0 -1.518 1.232 -2.75 2.75 -2.75 c 1.518 0 2.75 1.232 2.75 2.75 C 13.95 13.818 12.718 15.05 11.2 15.05 z"
        ],
        iconName: "preview",
        prefix: "exo"
    },

    react: {
        icon: [
            260,
            260,
            [],
            "f111",
            "M 128.83 182.165 l -6.94 -20.81 c -1.64 -4.905 -6.22 -8.205 -11.39 -8.205 s -9.75 3.295 -11.39 8.205 l -9.11 27.325 c -0.75 2.29 -2.89 3.82 -5.295 3.82 h -6.205 c -4.42 0 -8 3.58 -8 8 s 3.58 8 8 8 h 6.205 c 9.31 0 17.545 -5.94 20.485 -14.765 l 5.31 -15.945 l 8.405 25.24 a 7.997 7.997 90 0 0 7.03 5.445 c 0.19 0.015 0.375 0.025 0.56 0.025 c 3.015 0 5.795 -1.705 7.155 -4.43 l 3.83 -7.665 c 1.39 -2.795 3.97 -3.095 5.015 -3.095 s 3.625 0.295 5.095 3.265 c 3.69 7.35 11.095 11.92 19.31 11.92 h 7.6 c 4.42 0 8 -3.58 8 -8 s -3.58 -8 -8 -8 h -7.595 c -2.14 0 -4.06 -1.19 -5.08 -3.25 c -5.965 -11.925 -23.12 -15.165 -32.995 -7.08 z m 86.585 -132.675 l -41.945 -41.94 c -4.5 -4.5 -10.6 -7.05 -16.945 -7.05 h -102.03 c -13.245 0.05 -23.995 10.8 -23.995 24.045 v 207.96 c 0 13.245 10.75 23.995 23.995 23.995 h 143.97 c 13.25 0 24.035 -10.75 24.035 -23.995 v -166.02 c 0 -6.345 -2.585 -12.495 -7.085 -16.995 z m -56.94 -22.995 l 38.045 38.04 h -38.045 v -38.04 z m 40.025 206.01 h -144.005 v -207.96 h 79.985 v 51.99 c 0 6.65 5.35 11.995 12 11.995 h 52.02 v 143.975 z m -124 -176.005 h 40 c 2.21 0 4 -1.79 4 -4 v -8 c 0 -2.21 -1.79 -4 -4 -4 h -40 c -2.21 0 -4 1.79 -4 4 v 8 c 0 2.21 1.79 4 4 4 z m 0 32 h 40 c 2.21 0 4 -1.79 4 -4 v -8 c 0 -2.21 -1.79 -4 -4 -4 h -40 c -2.21 0 -4 1.79 -4 4 v 8 c 0 2.21 1.79 4 4 4 z"
        ],
        iconName: "react",
        prefix: "exo"
    },

    react_add: {
        icon: [
            384,
            512,
            [],
            "f111",
            "M369.9,97.9,286,14A48,48,0,0,0,252.1-.1H48A48.16,48.16,0,0,0,0,48V464a48,48,0,0,0,48,48H336a48,48,0,0,0,48-48V131.9A48.23,48.23,0,0,0,369.9,97.9ZM256,51.9,332.1,128H256ZM336,464H48V48H208V152a23.94,23.94,0,0,0,24,24H336ZM215,223.75a16,16,0,0,0-16-16H183a16,16,0,0,0-16,16v56.5h-55.5a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16H167v56a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16v-56h56.5a16,16,0,0,0,16-16v-16a16,16,0,0,0-16-16H215Z"
        ],
        iconName: "react_add",
        prefix: "exo"
    },

    files: {
        icon: [
            640,
            640,
            [],
            "f111",
            "M592 64H400L345.37 9.37c-6-6-14.14-9.37-22.63-9.37H176c-26.51 0-48 21.49-48 48v80H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48v-80h80c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zM464 464H48V176h80v160c0 26.51 21.49 48 48 48h288v80zm128-128H176V48h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H592v224z"
        ],
        iconName: "files",
        prefix: "exo"
    },

    info: {
        icon: [
            512,
            512,
            [],
            "f111",
            "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm0-338c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
        ],
        iconName: "info",
        prefix: "exo"
    },

    collapse: {
        icon: [
            1000,
            900,
            [],
            "f111",
            "M945.230769 187.076923c0-15.753846-13.784615-29.538462-29.538461-29.538461h-807.384616C92.553846 157.538462 78.769231 171.323077 78.769231 187.076923v59.076923c0 15.753846 13.784615 29.538462 29.538461 29.538462h807.384616c15.753846 0 29.538462-13.784615 29.538461-29.538462v-59.076923z m0 590.769231c0-15.753846-13.784615-29.538462-29.538461-29.538462h-807.384616c-15.753846 0-29.538462 13.784615-29.538461 29.538462v59.076923c0 15.753846 13.784615 29.538462 29.538461 29.538461h807.384616c15.753846 0 29.538462-13.784615 29.538461-29.538461v-59.076923zM679.384615 571.076923c15.753846 0 29.538462-13.784615 29.538462-29.538461v-59.076924c0-15.753846-13.784615-29.538462-29.538462-29.538461h-334.76923c-15.753846 0-29.538462 13.784615-29.538462 29.538461v59.076924c0 15.753846 13.784615 29.538462 29.538462 29.538461h334.76923z"
        ],
        iconName: "collapse",
        prefix: "exo"
    },

    terminate: {
        icon: [
            24,
            24,
            [],
            "f112",
            "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
        ],
        iconName: "terminate",
        prefix: "exo"
    },
    json: {
        icon: [
            16,
            16,
            [],
            "f113",
            "M6 2.984V2h-.09c-.313 0-.616.062-.909.185a2.33 2.33 0 0 0-.775.53a2.23 2.23 0 0 0-.493.753v.001a3.542 3.542 0 0 0-.198.83v.002a6.08 6.08 0 0 0-.024.863c.012.29.018.58.018.869c0 .203-.04.393-.117.572v.001a1.504 1.504 0 0 1-.765.787a1.376 1.376 0 0 1-.558.115H2v.984h.09c.195 0 .38.04.556.121l.001.001c.178.078.329.184.455.318l.002.002c.13.13.233.285.307.465l.001.002c.078.18.117.368.117.566c0 .29-.006.58-.018.869c-.012.296-.004.585.024.87v.001c.033.283.099.558.197.824v.001c.106.273.271.524.494.753c.223.23.482.407.775.53c.293.123.596.185.91.185H6v-.984h-.09c-.2 0-.387-.038-.563-.115a1.613 1.613 0 0 1-.457-.32a1.659 1.659 0 0 1-.309-.467c-.074-.18-.11-.37-.11-.573c0-.228.003-.453.011-.672c.008-.228.008-.45 0-.665a4.639 4.639 0 0 0-.055-.64a2.682 2.682 0 0 0-.168-.609A2.284 2.284 0 0 0 3.522 8a2.284 2.284 0 0 0 .738-.955c.08-.192.135-.393.168-.602c.033-.21.051-.423.055-.64c.008-.22.008-.442 0-.666c-.008-.224-.012-.45-.012-.678a1.47 1.47 0 0 1 .877-1.354a1.33 1.33 0 0 1 .563-.121H6zm4 10.032V14h.09c.313 0 .616-.062.909-.185c.293-.123.552-.3.775-.53c.223-.23.388-.48.493-.753v-.001c.1-.266.165-.543.198-.83v-.002c.028-.28.036-.567.024-.863c-.012-.29-.018-.58-.018-.869c0-.203.04-.393.117-.572v-.001a1.502 1.502 0 0 1 .765-.787a1.38 1.38 0 0 1 .558-.115H14v-.984h-.09c-.196 0-.381-.04-.557-.121l-.001-.001a1.376 1.376 0 0 1-.455-.318l-.002-.002a1.415 1.415 0 0 1-.307-.465v-.002a1.405 1.405 0 0 1-.118-.566c0-.29.006-.58.018-.869a6.174 6.174 0 0 0-.024-.87v-.001a3.537 3.537 0 0 0-.197-.824v-.001a2.23 2.23 0 0 0-.494-.753a2.331 2.331 0 0 0-.775-.53a2.325 2.325 0 0 0-.91-.185H10v.984h.09c.2 0 .387.038.562.115c.174.082.326.188.457.32c.127.134.23.29.309.467c.074.18.11.37.11.573c0 .228-.003.452-.011.672c-.008.228-.008.45 0 .665c.004.222.022.435.055.64c.033.214.089.416.168.609a2.285 2.285 0 0 0 .738.955a2.285 2.285 0 0 0-.738.955a2.689 2.689 0 0 0-.168.602c-.033.21-.051.423-.055.64a9.15 9.15 0 0 0 0 .666c.008.224.012.45.012.678a1.471 1.471 0 0 1-.877 1.354a1.33 1.33 0 0 1-.563.121H10z"
        ],
        iconName: "json",
        prefix: "exo"
    },
};
